import { Observable, EMPTY as EMPTY_OBSERVABLE } from 'rxjs'
import {
  TOKENS_OPERATOR_LABELS,
  TOKENS_CAN_BE_COMPLETED
} from '@aytm/app/stats/lib/draft-js/autocompletePlugin/lib/tokens'
import processSuggestionData from '@aytm/app/stats/lib/draft-js/autocompletePlugin/lib/process-suggestion-data'

const transformToSuggestion =
  ({ canBeCompleted, parserResult }) =>
  ({ token, label }) =>
    processSuggestionData('operator', { canBeCompleted, parserResult, token, label })

export const reduceTokensToOperators = textBefore => (operators, token) => {
  if (TOKENS_OPERATOR_LABELS[token]) {
    const label =
      'function' === typeof TOKENS_OPERATOR_LABELS[token]
        ? TOKENS_OPERATOR_LABELS[token](textBefore)
        : TOKENS_OPERATOR_LABELS[token]
    if (Array.isArray(label)) {
      label.forEach(label => {
        operators.push({ token, label })
      })
    } else {
      operators.push({ token, label })
    }
  }
  return operators
}

export default function createOperatorSuggestion(textBefore, _, { dependencies: { parserResult, aytmLogic } }) {
  if (!parserResult) {
    return EMPTY_OBSERVABLE
  }

  const createSuggestions = (tokens, canBeCompleted) =>
    tokens
      .reduce(reduceTokensToOperators(textBefore.trimmed), [])
      .map(transformToSuggestion({ canBeCompleted, parserResult }))
      .filter(suggestion => suggestion)

  return new Observable(observer => {
    const {
      tokens: { expected, type },
      text: { nonParsed }
    } = parserResult

    const isLastTokenCompletable = TOKENS_CAN_BE_COMPLETED.includes(type.last)
    const hasNonParsedText = Boolean(nonParsed)
    const hasNonParsedTextTrimmed = Boolean(nonParsed.trim())
    const canBeCompleted = Boolean(hasNonParsedTextTrimmed || (!hasNonParsedText && isLastTokenCompletable))

    const suggestedLabels = []
    let suggestionTokens =
      !hasNonParsedText && isLastTokenCompletable ? expected.prelast || expected.last || [] : expected.last || []

    if (
      'BREF' === type.last &&
      'IN_SECTION' !== type.prelast &&
      aytmLogic?.sections?.length &&
      !suggestionTokens.includes('IN_SECTION')
    ) {
      suggestionTokens = [...suggestionTokens, 'IN_SECTION']
    }

    createSuggestions(suggestionTokens, canBeCompleted).forEach(suggestion => {
      suggestedLabels.push(suggestion.label)
      observer.next(suggestion)
    })

    if (canBeCompleted && suggestionTokens === expected.prelast) {
      createSuggestions(expected.last || [])
        .filter(suggestion => !suggestedLabels.includes(suggestion.label))
        .forEach(suggestion => observer.next(suggestion))
    }

    observer.complete()
  })
}
